module.exports = __webpack_public_path__ + "img/Frame 717.93030d11.png";